import _ from 'underscore';
import React, { useContext, useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { GroupsLayoutControls } from './controls';
import { getCarouselOverrideStyles, getGroupsLayoutStyles } from './styles';


export const GroupsPreviewer = (props) => {
  const {
    groups,
    defaultGroup,
    previewers,
    adData,
    decoratorsData,
    images,
    headerButtonProps,
    onActiveGroupChange,
  } = props;

  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getGroupsLayoutStyles);
  const carouselClasses = useDefaultStyles(getCarouselOverrideStyles);

  const [activeGroupKey, setActiveGroupKey] = useState(groups[0].key);

  const handleSetActiveGroupKey = useCallback((groupKey) => {
    setActiveGroupKey(groupKey);
    onActiveGroupChange(groupKey);
  }, [onActiveGroupChange]);

  useEffect(() => {
    if (defaultGroup) {
      setActiveGroupKey(defaultGroup);
    }
  }, [defaultGroup]);

  return (
    <div className="groups-previewer">
      <GroupsLayoutControls
        i18n={i18n}
        groups={groups}
        activeGroupKey={activeGroupKey}
        onChangeActiveGroupKey={handleSetActiveGroupKey}
      />
      <div className={classes.groupContainer}>
        {
          _.map(groups, ({ key }) => {
            const Previewer = previewers[key];

            return (
              <div
                className={classnames(
                  'group-previewer',
                  carouselClasses.carouselContainer,
                  key !== activeGroupKey && classes.inactiveGroup
                )}
              >
                <Previewer
                  key={key}
                  adData={adData}
                  decoratorsData={decoratorsData}
                  imagesToDisplay={images}
                  headerButtonProps={headerButtonProps}
                  hideNavigationControlsIfSingle
                />
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

GroupsPreviewer.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    predicate: PropTypes.func.isRequired,
  })).isRequired,
  defaultGroup: PropTypes.string,
  onActiveGroupChange: PropTypes.func,
  previewers: PropTypes.shape({}).isRequired,
  adData: PropTypes.shape({}).isRequired,
  decoratorsData: PropTypes.shape({}),
  images: PropTypes.arrayOf(PropTypes.shape({})),
  headerButtonProps: PropTypes.shape({
    onEdit: PropTypes.func.isRequired,
    onAddAspectRatio: PropTypes.func.isRequired,
    onRemoveAspectRatio: PropTypes.func.isRequired,
  }).isRequired,
};

GroupsPreviewer.defaultProps = {
  defaultGroup: null,
  onActiveGroupChange: _.noop,
  decoratorsData: {},
  images: [],
};
